import * as React from "react";

function SvgContact(props) {
  return (
    <svg width={28} height={28} fill="none" viewBox="0 0 28 28" {...props}>
      <path d="M24.5 0H3.5C1.57227 0 0 1.57227 0 3.45078V19.1516C0 21.0793 1.57227 22.6023 3.5 22.6023H8.75V27.2945C8.75 27.8276 9.36523 28.1395 9.79562 27.8249L16.625 22.7008H24.5C26.4277 22.7008 28 21.1285 28 19.25V3.45078C28 1.57227 26.4305 0 24.5 0ZM20.125 14.4375C20.125 15.1648 19.5398 15.75 18.8125 15.75C18.0852 15.75 17.5 15.1648 17.5 14.4375V10.6039L12.25 15.8539C11.737 16.3669 10.9069 16.3665 10.3939 15.8539C9.88203 15.3453 9.88203 14.5141 10.3961 14L15.6461 8.75H11.8125C11.0906 8.75 10.5 8.16484 10.5 7.4375C10.5 6.71016 11.0906 6.125 11.8125 6.125H18.8125C19.5371 6.125 20.125 6.71289 20.125 7.4375V14.4375Z" />
    </svg>
  );
}

export default SvgContact;
